// Registers /sw.js globally for every public page, not just the operator
// dashboard. A registered, active service worker is one of the browser's
// installability requirements for "Add to Home Screen" / PWA install
// prompts — without it (as before), beforeinstallprompt never fires.
const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1"
);

export function register() {
  if (!("serviceWorker" in navigator)) return;
  if (window.location.protocol !== "https:" && !isLocalhost) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .catch((error) => {
        console.error("Service worker registration failed:", error);
      });
  });
}
